module.exports = __webpack_public_path__ + "static/media/default.372e2c51.svg";